import HierarchySelection from '../../../../dataViews/NextTree/plugins/HierarchySelection';

export default {
  makeTreePlugin: canSelectNode =>
    new HierarchySelection({ nodeIsSelectable: canSelectNode }),
};
